<mat-toolbar class="px-3 gap-3 responsive-toolbar">
  <button
    matIconButton
    class="sidnav-toggle-btn"
    (click)="onToggleSidenav($event)"
    [attr.aria-expanded]="sideNavOpened()"
    [attr.aria-label]="sideNavOpened() ? 'Einklappen' : 'Ausklappen'"
  >
    <mat-icon>{{ sideNavOpened() ? "menu_open" : "menu" }}</mat-icon>
  </button>
  <a
    class="app-logo"
    routerLink="/"
    title="Historische Unterlagen St. Gallens jederzeit online verfügbar. Wir bringen die Geschichte des Kantons durch Digitalisierung direkt zu Ihnen."
  >
    <span class="app-logo-text mat-headline-medium m-0 mb-1">{{ "TOPNAV.TITLE" | translate }}</span>
  </a>

  <app-quick-search #searchInput class="force-light-theme ml-auto"></app-quick-search>

  <a matButton="outlined" href="https://publikationen.sg.ch/amtliche-publikationen/" target="_blank">Zur Publikationsplattform</a>

  @if (isLoggedIn$ | async) {
    <button mat-button [disabled]="loading()" [matMenuTriggerFor]="userMenu">
      <mat-icon>account_circle</mat-icon>
      {{ username$ | async }}
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="onLogout($event)">
        <mat-icon>exit_to_app</mat-icon>
        {{ "TOPNAV.BTN_LOGOUT" | translate }}
      </button>
    </mat-menu>
  }
</mat-toolbar>
<mat-divider style="width: 100%" />
&nbsp;
